export enum BookingStatus {
  NEW = 'New',
  RESERVED = 'Reserved',
  CANCELED = 'Canceled',
  COMPLETED = 'Completed',
}

export const bookingStatusList = [
  { value: BookingStatus.NEW, label: 'New' },
  { value: BookingStatus.RESERVED, label: 'Reserved' },
  { value: BookingStatus.CANCELED, label: 'Canceled' },
  { value: BookingStatus.COMPLETED, label: 'Completed' },
]

export enum PickupTimes {
  SEVEN_TO_NINE = '07:00 - 09:00',
  NINE_TO_ELEVEN = '09:00 - 11:00',
  ELEVEN_TO_THIRTEEN = '11:00 - 13:00',
}

export const pickupTimesList = [
  { value: PickupTimes.SEVEN_TO_NINE, label: '07:00 - 09:00' },
  { value: PickupTimes.NINE_TO_ELEVEN, label: '09:00 - 11:00' },
  { value: PickupTimes.ELEVEN_TO_THIRTEEN, label: '11:00 - 13:00' },
]
